import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class SortIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">

				<g>
					<path fill="currentColor" d="M0 853.333h341.333v-113.778h-341.333v113.778zM0 170.667v113.778h1024v-113.778h-1024zM0 568.889h682.667v-113.778h-682.667v113.778z"></path>
				</g>

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
